import { to } from 'helpers/Async';
import { MembershipEventService } from 'modules/membershipEvent';
import { UiService } from 'modules/ui';

export default {
  dismiss: async (eventName) => {
    if (!eventName) {
      return [];
    }

    const [error, response] = await to(
      MembershipEventService.dismissEvent(eventName)
    );

    if (error) {
      UiService.handleError(error);
    }

    return [error, response];
  }
};
